import { render, staticRenderFns } from "./saldo.vue?vue&type=template&id=96957a2e&"
import script from "./saldo.vue?vue&type=script&lang=js&"
export * from "./saldo.vue?vue&type=script&lang=js&"
import style0 from "./saldo.vue?vue&type=style&index=0&id=96957a2e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports